/**
 * Hydratation opportuniste API → Dexie (mares tierces / viewport détail).
 */
import config from 'config';
import * as repo from 'db/repositories';

/**
 * GET JSON → objet ou null.
 */
function fetchJson( url, data )
{
	var deferred = $.Deferred();

	$.ajax( {
		url: url,
		method: 'GET',
		dataType: 'json',
		data: data || {},
	} ).done( function( json )
	{
		deferred.resolve( json || null );
	} ).fail( function()
	{
		deferred.resolve( null );
	} );

	return deferred.promise();
}

/**
 * Liste paginée API → tableau plat.
 */
function fetchAllPages( url, data )
{
	var deferred = $.Deferred();
	var all = [];
	var offset = 0;
	var limit = 1000;

	var next = function()
	{
		fetchJson( url, _.extend( {}, data, { offset: offset, limit: limit } ) ).done( function( json )
		{
			if( !json )
			{
				deferred.resolve( all );
				return;
			}

			var list = _.isArray( json ) ? json : ( json.data || [] );
			all = all.concat( list );

			if( json.has_more )
			{
				offset += limit;
				next();
				return;
			}

			deferred.resolve( all );
		} );
	};

	next();
	return deferred.promise();
}

/**
 * Hydrate Dexie depuis l'API (mare + visites + images).
 */
export function hydratePondFromApi( uuid )
{
	var deferred = $.Deferred();

	if( !app.is( 'online' ) )
	{
		deferred.resolve( false );
		return deferred.promise();
	}

	$.when(
		fetchJson( config.url.pond + '/' + encodeURIComponent( uuid ) ),
		fetchAllPages( config.url.visit, { pond_uuid: uuid, published: 1 } ),
		fetchAllPages( config.url.image, { pond_uuid: uuid, published: 1 } )
	).done( function( pondJson, visits, images )
	{
		if( !pondJson || pondJson.error )
		{
			deferred.resolve( false );
			return;
		}

		repo.putPond( pondJson ).then( function()
		{
			return Promise.all( [
				visits && visits.length ? repo.putVisits( visits ) : Promise.resolve(),
				images && images.length ? repo.putImages( images ) : Promise.resolve(),
			] );
		} ).then( function()
		{
			deferred.resolve( true );
		} ).catch( function( err )
		{
			console.error( 'hydratePondFromApi', err );
			deferred.resolve( false );
		} );
	} );

	return deferred.promise();
}
